import { UntypedFormControl } from "@angular/forms";

export enum FileMode {
  Create = 'create',
  Edit = 'edit',
  Delete = 'delete',
}

export interface FileSetting {
  id?: number;
  name: string;
  status?: string;
  size?: string;
  type?: string;
  mode: FileMode;
  control?: UntypedFormControl;
  candidateControl?: UntypedFormControl;
  changable?: boolean;
}

export type FileSettings = { [key: string]: FileSetting };
